import getters from './getters';
import actions from './actions';
import mutations from './mutations';
const state = {
  id: null,
  email: null,
  username: null,
  isActive: false,
  isSuperuser: false,
  isStaff: false,
  groups: [],
  permissions: [],
  data: null
};
export default {
  state,
  getters,
  actions,
  mutations
};
